import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

import { removeSellerFirstVisitCookie } from '@/lib/utils/cookies';
import { wait } from '@/lib/utils/time';

import { authKeys } from '../keys';
import { clearSuccessAuth } from '../utils/auth';

const logout = async () => {
  // Clear auth data from localStorage
  clearSuccessAuth();

  // Remove the seller_first_visit cookie
  removeSellerFirstVisitCookie();

  return {
    success: true,
  };
};

export const useLogout = () => {
  const router = useRouter();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: async () => {
      queryClient.setQueryData(authKeys.currentUser, null);

      router.push('/');

      await wait(1500);
      window.location.reload();
    },
  });
};
